// Number.EPSILON
if (Number.EPSILON === undefined) {
    Number.EPSILON = 2 ** -52;
}

// get parent using selector
const getClosest = (elem, selector) => {
    for (let element = elem; element && element !== document; element = element.parentNode) {
        if (element.matches(selector)) return element;
    }
    return null;
};

// handle promise response
const handleResponse = (response) => (
    response.json()
        .then((json) => {
            if (response.ok) return json;

            const error = Object.assign(...json, {
                status: response.status,
                statusText: response.statusText,
            });

            return Promise.reject(error);
        })
);

// wait for event
const waitForEvent = (element, eventName) => (
    new Promise((resolve) => {
        const done = (event) => {
            if (event.target === element) {
                element.removeEventListener(eventName, done);
                resolve(event);
            }
        };
        element.addEventListener(eventName, done);
    })
);

export {
    getClosest,
    handleResponse,
    waitForEvent,
};
